import { render, staticRenderFns } from "./CreateSchoolBrand.vue?vue&type=template&id=2d775e50&scoped=true"
import script from "./CreateSchoolBrand.vue?vue&type=script&lang=js"
export * from "./CreateSchoolBrand.vue?vue&type=script&lang=js"
import style0 from "./CreateSchoolBrand.vue?vue&type=style&index=0&id=2d775e50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d775e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d775e50')) {
      api.createRecord('2d775e50', component.options)
    } else {
      api.reload('2d775e50', component.options)
    }
    module.hot.accept("./CreateSchoolBrand.vue?vue&type=template&id=2d775e50&scoped=true", function () {
      api.rerender('2d775e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/CreateSchoolBrand.vue"
export default component.exports